import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { T } from '../stores/textStore';
import shopStore from '../stores/shopStore';


class AmountSelector extends Component {	
	constructor(props) {
		super(props);	
		let amount = '100.00';
		let amounts = ['100.00']
		if (window.tkcWidgetContext.amounts) {
			amount = window.tkcWidgetContext.amounts[0];
			amounts = window.tkcWidgetContext.amounts;
		}
		this.state = {
			amount: amount,
			amounts: amounts,
			//sku: null,
			amountInputPlaceholderText: '',
		}
	}

	getCurrency() {		
		const { currency } = shopStore;		
		return currency.get();
	}	

	handleAmountChange = event => {
		event.preventDefault();
		if (!isNaN(event.target.value)) {
			this.setState({ amount: event.target.value });
		}
	}

	handleAmountClick = (event, amount) => {
		event.preventDefault();
		this.setState({ amount: amount });		
	}

	handleOtherAmountClick = (event) => {
		event.preventDefault();				
		this.setState({ amount: '', amountInputPlaceholderText: 'Enter amount' });	
		this.inputRef.current.focus();	
	}	

	handleSubmit = (event) => {	
		event.preventDefault();			
		const context = window.tkcWidgetContext;
		shopStore.setCart([context.sku], null, this.state.amount, context.ticketId);
	}	
	
	isFormValid() {
		return (this.state.amount != null);
	}		
	renderAmountButton(amount) {
		return (
			<button 
				className="btn btn-outline-secondary mb-2" 
				onClick={event => this.handleAmountClick(event, amount)}
			>
				{this.getCurrency().symbol}{amount}
			</button>
		);
	}

	renderOtherAmountButton() {
		return (
			<button 
				className="btn btn-secondary mb-2" 
				onClick={this.handleOtherAmountClick}
			>
				{T('Other')}
			</button>
		);
	}

	renderAmountChooser() {	
		this.inputRef = React.createRef();			
		return (
			<form 
				className="needs-validation" 			
				noValidate 
				onSubmit={this.handleSubmit}
			>						
				<div className="row">																		
					<div className="col-sm-12">
						<label>
							{T('Choose a contribution amount')}&nbsp;
							{T('(the suggested contribution is')}&nbsp;
							{this.getCurrency().symbol}{window.tkcWidgetContext.amounts[0]}
							{T(', but we will appreciate any contribution).')}
						</label>				
					</div>
					{this.state.amounts.map(a => (
						<div className="col-sm-12 form-group" key={a}>					
							{this.renderAmountButton(a)} &nbsp;
							{this.renderOtherAmountButton()}&nbsp;
						</div>
					))}
					<div className="col-sm-6 form-group">
						<div className="input-group">
							<div className="input-group-prepend">
								<div className="input-group-text">
									{this.getCurrency().code} {this.getCurrency().symbol}
								</div>
							</div>
							<input 
								className="form-control form-control-lg"
								value={this.state.amount}									
								placeholder={this.state.amountInputPlaceholderText}
								onChange={this.handleAmountChange}
								ref={this.inputRef}
							/>
						</div>
					</div>													
					<div className="col-sm-4 form-group">
						<button 
							type="submit" 
							className="tkc-btn btn-block tkc-btn-red" 	
							disabled={!this.isFormValid()}																					
						>
							{T('Proceed')}
						</button>					
					</div>
				</div>				
			</form>
		);
	}

    render() {		
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						{this.renderAmountChooser()}																  
					</div>					
				</div>
			</div>
		);
    }

}

export default observer(AmountSelector);



// WEBPACK FOOTER //
// ./src/components/AmountSelector.js